jQuery(function($) {
    const appParam = 'open_from=app';
    const currentOrigin = window.location.origin;
    const currentHost = window.location.hostname;

    const hasParam = window.location.search.includes(appParam);
    if (hasParam) sessionStorage.setItem('open_from_app', 'true');

    const isFromApp = sessionStorage.getItem('open_from_app') === 'true';
    if (!isFromApp) return;

    $('.main-wrap a').each(function() {
        const link = $(this);
        const href = link.attr('href');

        if (!href || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('#')) return;

        // Parsear el href con URL (funciona con absolutas y relativas)
        let url;
        try {
            url = new URL(href, currentOrigin); // Relativas se resuelven bien
        } catch (e) {
            return; // Si falla al parsear, salimos
        }

        // Solo modificar si es del mismo dominio
        if (url.hostname !== currentHost) return;
        if (url.searchParams.has('open_from')) return;

        url.searchParams.append('open_from', 'app');
        link.attr('href', url.toString());
    });
});